module.exports = __webpack_public_path__ + "img/people-5-min.fde72cba.png";